import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
	state:{
		count:1,
		msg:'这里是state的初始化数据。',
    defineWebURL: 'https://api.shuangma88.com/', //定义全局地址
	},
  mutations:{

  },
  actions:{

  }
})
export default store;
